import { useMutation } from '@apollo/client';

import {
  EditPurchaseOrder,
  EditPurchaseOrderVariables,
} from '@/graphql/contracts/_generated_/editPurchaseOrder.mutation';
import EditPurchaseOrderMutation from '@/graphql/contracts/editPurchaseOrder.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';

export default function useEditPurchaseOrder() {
  const [_editPurchaseOrder, { loading, error }] = useMutation<
  EditPurchaseOrder,
  EditPurchaseOrderVariables
  >(EditPurchaseOrderMutation, {
    client: apolloClientContracts,
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });
  const editPurchaseOrder = async (fields: EditPurchaseOrderVariables, successCb?: () => void) => {
    return _editPurchaseOrder({
      variables: { ...fields },
      onCompleted: () => {
        notificationService.open({
          title: 'Edit Puchase Order',
          text: 'Purchase Order successfully edited',
          type: 'success',
        });
        if (successCb) {
          successCb();
        }
      },
    });
  };

  return {
    editPurchaseOrder,
    isLoadingEditPurchaseOrder: loading,
    errorEditPurchaseOrders: error,
  } as const;
}
